import Link from 'next/link';

import { Anchor, Group, Stack, Text } from '@mantine/core';

import { CompanyProfile } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { CompanyProfileService } from 'services/CompanyProfileService';

const UnclaimedProfileDisclaimer = ({ company }: { company: CompanyProfile }) => {
    if (!company.internal) return null;

    return (
        <Stack gap="xs" p="md" mb="xl" maw={720} mx="auto" align="center" bg="gray.0" bdrs="md">
            <Text fz="xs" c="dimmed" ta="center">
                Compiled by Direct Energy Partners from publicly available information. {company.name} has not claimed
                this profile and is not affiliated with Direct Energy Partners. All trademarks are the property of their
                respective owners.
            </Text>
            <Group gap="md">
                <Anchor
                    fz="xs"
                    c="dimmed"
                    td="underline"
                    component={Link}
                    href={CompanyHelpers.urls.requestAccess(company.slug)}
                >
                    Claim this profile
                </Anchor>
                <Anchor
                    fz="xs"
                    c="dimmed"
                    td="underline"
                    component="button"
                    onClick={() => CompanyProfileService.openRequestRemovalModal(company)}
                >
                    Request removal
                </Anchor>
                <Anchor
                    fz="xs"
                    c="dimmed"
                    td="underline"
                    href={CompanyHelpers.urls.reportIncorrectInformation(company.name)}
                >
                    Report incorrect information
                </Anchor>
            </Group>
        </Stack>
    );
};

export { UnclaimedProfileDisclaimer };
